"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CircleTicks = function CircleTicks(_ref) {
  var theme = _ref.theme,
      inverted = _ref.inverted,
      origin = _ref.origin,
      scales = _ref.scales,
      tickCount = _ref.tickCount,
      hidden = _ref.hidden;
  if (hidden) return null;
  var labelPadding = 5;
  var ticks = scales.north.ticks(5).slice(1, tickCount + 1);
  var attrs = {
    cx: origin.x,
    cy: origin.y,
    fill: 'none',
    stroke: inverted ? theme.inverted.one[1] : theme.one[0],
    strokeWidth: '1px',
    strokeOpacity: '0.1'
  };
  var circles = ticks.map(function (tick, i) {
    return /*#__PURE__*/_react.default.createElement("circle", _extends({}, attrs, {
      key: i,
      r: origin.y - scales.north(tick)
    }));
  });
  var labels = ticks.map(function (tick, i) {
    return /*#__PURE__*/_react.default.createElement("text", {
      key: i,
      x: origin.x - labelPadding,
      y: scales.north(tick) + labelPadding,
      textAnchor: "end",
      alignmentBaseline: "hanging",
      fontFamily: theme.font2,
      fontWeight: "300",
      fontSize: "10px",
      fill: theme.default,
      fillOpacity: "0.3"
    }, tick * 100);
  });
  return /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", null, labels), /*#__PURE__*/_react.default.createElement("g", null, circles));
};

CircleTicks.propTypes = {
  scales: _propTypes.default.shape({
    north: _propTypes.default.func.isRequired,
    east: _propTypes.default.func.isRequired,
    south: _propTypes.default.func.isRequired,
    west: _propTypes.default.func.isRequired
  }).isRequired,
  origin: _propTypes.default.shape({
    x: _propTypes.default.number.isRequired,
    y: _propTypes.default.number.isRequired
  }).isRequired,
  tickCount: _propTypes.default.number,
  hidden: _propTypes.default.bool,
  inverted: _propTypes.default.bool
};
CircleTicks.defaultProps = {
  tickCount: 10,
  hidden: false,
  inverted: false
};

var _default = (0, _styledComponents.withTheme)(CircleTicks);

exports.default = _default;
//# sourceMappingURL=CircleTicks.js.map